import CollectionDetailPage from '../CollectionDetailPage';
export default function DiningRoomPage() { return <CollectionDetailPage collectionId="dining-room" />; }
